import npm from '../../package.json';

export const security = {
  key: "howfjhkwcohjpijpjrepjk",
};
export const environment = {
  env: "uat",
  firebase: {
    apiKey: "AIzaSyDMIgp0uyBYgCl2-vkLr0XUMMG0U6UvGLY",
    authDomain: "newmyald.firebaseapp.com",
    projectId: "newmyald",
    storageBucket: "newmyald.appspot.com",
    messagingSenderId: "431046610992",
    appId: "1:431046610992:web:90c970210179db88761df5",
    measurementId: "G-0J592TWZFX",
    vapidKey:
      "BCOuOOIOxuXblejMX_dhng7yefMh-rjVvzrUkftYx8OcKmJcNlnxk7zUeFFp3DQz8exaYlQ1NZHAGffFfUleWHg",
  },
  production: true,
  version: npm.version,
  nemo_claims_callback: "https://nemo-uat.aldautomotive.it/#/",
  apim: "https://api.staging.aldautomotive.com/uat/myaldns",
  clientServiceTelephone: "800 426 426",
  clientPurchaseTelephone: "800 916 492",
  purchaseUsedEmail: "usato@aldautomotive.com",
  refuelsInfoEmail: "hd.fsl@aldautomotive.com",
  roadsideAssistanceTelephone: "800 826 001",
  date_format: "MM/YYYY",
  full_date_format: "DD/MM/YYYY",
  delegationArt94Link: "http://",
  earlyReturnEmail: "rientroanticipato@aldautomotive.com",
  mobile: false,
  assistanceEmail: "assistance@aldautomotive.com",
  ricaricar:
    "https://shop.aldautomotive.it/it/noleggio-lungo-termine/pay-per-use/ricarica-km-online/",
  car_sharing: "https://aldcarsharing.targatelematics.com",
  iam_passport: "https://uat-passport.aldautomotive.it",
  subscription: "subscription-key=0e028e3a8ca94c26a5c9b52b190171ed",
  OcpApimSubscriptionKey: "0e028e3a8ca94c26a5c9b52b190171ed",
  xAldSubscriptionKey: "0e028e3a8ca94c26a5c9b52b190171ed",
  manualSubscription: "0e028e3a8ca94c26a5c9b52b190171ed",
  recaptcha: {
    siteKey: "6Ld7Ex0qAAAAALreJemRqEJ36j44-KOiXhlLoiS2",
  },
};
export const endpoints = {
  userinfo_iam: `${environment.iam_passport}/oauth2/userinfo`,
  cities: `${environment.apim}/cms/cms/getcities`,
  provinces: `${environment.apim}/cms/cms/getprovinces`,
  countries: `${environment.apim}/cms/cms/getcountries`,
  titles: `${environment.apim}/cms/cms/gettitles`,
  get_content_cms: `${environment.apim}/cms/cms/image`,
  get_content_cms_document: `${environment.apim}/cms/cms/getdocumentpdf`,
  change_password: `${environment.apim}/user/mws-contact/change-password`,
  change_mail: `${environment.apim}/user/mws-contact/change-email`,
  my_vehicle: `${environment.apim}/vehicle/vehicle/my-vehicle`,
  user_full: `${environment.apim}/user/user/full-info`,
  contact_profile: `${environment.apim}/user/user/contact-profile`,
  menu_url: `${environment.apim}/user/user/menu-by-role`,
  home_cards_url: `${environment.apim}/cms/cms/gethomepagecards`,
  contacts_url: `${environment.apim}/cms/cms/getcontacts`,
  faq_url: `${environment.apim}/cms/cms/getfaq`,
  salesforce_category_details: `${environment.apim}/cms/cms/getsalesforcecategories`,
  faq_categories: `${environment.apim}/cms/cms/getcategories`,
  visor_url: `${environment.apim}/cms/cms/getviewers`,
  service_centers_ford: `${environment.apim}/cms/cms/getservicecenters`,
  maintenance_banner: `${environment.apim}/cms/cms/getmaintenancebanner`,
  informative_notes: `${environment.apim}/cms/cms/getinformativedisclaimer`,
  list_vehicle_export_url: `${environment.apim}/vehicle/vehicles/export`,
  list_vehicle_url: `${environment.apim}/vehicle/vehicle/vehicle-list`,
  list_vehicle_poc_url: `${environment.apim}/vehicle/vehicle/vehicle-list-poc`,
  list_vehicle_tyres_campaign_driver: `${environment.apim}/vehicle/vehicle/vehicle-list-for-tyres-campaign`,
  service_centers_url: `${environment.apim}/vehicle/service-centers`,
  detail_vehicle_url: `${environment.apim}/vehicle/vehicle/details`,
  km_manag_list: `${environment.apim}/vehicle/vehicle/km-management-list`,
  km_manag_list_export: `${environment.apim}/vehicle/vehicle/km-managements`,
  km_manag_list_contract: `${environment.apim}/vehicle/vehicle/km-management-list`,
  vehicle_assignment_url: `${environment.apim}/vehicle/vehicle/assigned-list`,
  vehicle_assignation: `${environment.apim}/vehicle/vehicle/assignation/`,
  vehicle_orders_url: `${environment.apim}/order/orders`,
  vehicle_orders_export_url: `${environment.apim}/order/orders-export`,
  drivers_to_assign: `${environment.apim}/vehicle/vehicle/drivers-assignment`,
  vehicle_order_detail: `${environment.apim}/order/order/details`,
  vehicle_order_status: `${environment.apim}/order/order/status`,
  vehicle_history: `${environment.apim}/vehicle/vehicle/driver-history`,
  vehicle_history_v2: `${environment.apim}/vehicle/vehicle/driver-history-v2`,
  consumption_archive_list: `${environment.apim}/vehicle/vehicle/ricaricar-balance`, // modifica ricaricar-list
  ricaricar_list: `${environment.apim}/vehicle/vehicle/ricaricar-list`,
  dashboard_km: `${environment.apim}/vehicle/vehicle/ricaricar-contract-data`,
  ricaricar_balance: `${environment.apim}/vehicle/vehicle/ricaricar-balance`,
  driver_pool_assignation: `${environment.apim}/vehicle/vehicle/driver-pool`,
  customers_list_export: `${environment.apim}/user/user/get-contacts-export`,
  check_email_user: `${environment.apim}/user/user/check-contact-by-email`,

  assignation: `${environment.apim}/vehicle/vehicle/assignation`,
  details_vehicle_url: `${environment.apim}/vehicle/vehicle/details`,
  drivers_assignment: `${environment.apim}/vehicle/vehicle/drivers-assignment`,
  assignation_details: `${environment.apim}/vehicle/vehicle/assignation-detail`,
  drivers_to_assign_export: `${environment.apim}/vehicle/vehicle/drivers-assignment/export`,
  update_last_login:`${environment.apim}/user/user/update-lastLogin`,


  // Tools and service
  ts_fines_post_94: `${environment.apim}/tool/tools/fines-post-art94`,
  sanitation: `${environment.apim}/tool/tools/sanitation-fleets`,
  statistics_and_monitoring: `${environment.apim}/tool/tools/mydatahub`,
  delegation_art_94: `${environment.apim}/tool/tools/info-delega-list`,
  delegation_art_94_by_customer: `${environment.apim}/tool/tools/info-delega-by-external-id-customer-id`,
  update_delegation_art_94: `${environment.apim}/tool/tools/update-delega-state`,
  sanitation_mail: `${environment.apim}/tool/tools/sanitation-customer-list-send-email`,
  ts_fines_post_94_url_fm: `${environment.apim}/tool/tools/fines-post-art94/get-url`,
  create_delega_user: `${environment.apim}/user/user/create-delega-user`,

  // Rifornimenti
  ts_refuels: `${environment.apim}/tool/tools/aggregated-refuels-list`,
  ts_refuels_export: `${environment.apim}/tool/tools/aggregated-refuels-list/export`,
  ts_refuels_history: `${environment.apim}/tool/tools/refuels-history`,
  ts_refuels_history_export: `${environment.apim}/tool/tools/refuels-history/export`,
  // ADMINISTRATION
  administration_invoice_archive: `${environment.apim}/management/administration/invoices`,
  administration_invoice_archive_download_zip: `${environment.apim}/management/administration/invoices-archive`,
  administration_invoice_archive_export: `${environment.apim}/management/administration/invoices-export`,
  administration_invoice_archive_export_selected: `${environment.apim}/management/administration/export-selected-receipt-invoices`,
  administration_invoice_archive_olsa: `${environment.apim}/management/administration/getArchivioDocuments`,
  administration_invoice_archive_olsa_export: `${environment.apim}/management/administration/getArchivioDocuments-export`,
  invoices_receipt: `${environment.apim}/management/administration/receipt-invoices`,
  invoices_receipt_export: `${environment.apim}/management/administration/receipt-invoices-export`,
  detail_invoice_receipt: `${environment.apim}/management/administration/receipt-invoice-detail`,
  forwarding_invoice: `${environment.apim}/management/administration/forwarding-invoice`,
  // credit_card_service_list: `${environment.apiUrl}/creditCardServiceList`,
  credit_card_service_list: `${environment.apim}/management/administration/payments/recurring/billingagreement-client-list`,
  inizialize_billingagreement: `${environment.apim}/management/administration/payments/recurring/inizialize-billingagreement`,
  create_billingagreement: `${environment.apim}/management/administration/payments/recurring/create-billingagreement`,
  paypal_payment: `${environment.apim}/management/administration/execute-payment/paypal`,
  mybank_payment: `${environment.apim}/management/administration/payments/mybank/initialize-payment`,
  add_transaction: `${environment.apim}/management/administration/payments/transaction/add`,
  update_transaction: `${environment.apim}/management/administration/payments/transaction/update`,

  forwarding_docs: `${environment.apim}/management/administration/forwarding-docs`,
  reactivationDriversList: `${environment.apim}/management/administration/corporate-quoter/riattivazione-driver`,
  updateQuoteId: `${environment.apim}/management/administration/corporate-quoter/update-quoteid`,


  // Payments
  online_payment: `${environment.apim}/management/administration/pagaonline-active-invoices`,
  archive_document: `${environment.apim}/management/administration/documents`,
  document_types: `${environment.apim}/management/administration/document-types`,
  document_detail: `${environment.apim}/management/administration/document-detail`,
  document: `${environment.apim}/management/administration/document`,
  download_document_zip: `${environment.apim}/management/administration/zipped_documents`,
  pagaonline_download_invoice: `${environment.apim}/management/administration/pagaonline-download-invoice`,
  notify_payment_url_myBank: `${environment.apim}/management/administration/payments/mybank/notify-payment?${environment.subscription}`,
  notify_payment_url_myBank_recur: `${environment.apim}/management/administration/payments/mybank/notify-payment-recur?${environment.subscription}`,
  esito_pagamento:`${environment.apim}/management/administration/payments/recurring/verify-nexi-transaction`,


  // Maintenance and appointments
  appointmentsListExport: `${environment.apim}/order/appointments-export`,
  maintenances: `${environment.apim}/management/maintenances`,
  export_maintenance: `${environment.apim}/management/maintenances/export`,
  export_maintenance_poste: `${environment.apim}/order/canalidigitali/pratiche/export`,
  maintenance_history: `${environment.apim}/management/maintenance/details`,
  tireList: `${environment.apim}/vehicle/pug/tyres-info`,
  tireTransfer: `${environment.apim}/vehicle/vehicle/get-transfer-rate`,
  tireMovementsList: `${environment.apim}/vehicle/pug/tyres-info`,
  tireReleaseList: `${environment.apim}/vehicle/pug/tyres-info`,
  tiresMovementExport: `${environment.apim}/vehicle/pug/tyres-info-export`,
  tireCampaignHistory: `${environment.apim}/vehicle/vehicle/tyres-campaign-history`,
  tiresCampaignHistoryExport: `${environment.apim}/vehicle/vehicle/tyres-campaign-history-export`,
  createDepositRelease: `${environment.apim}/vehicle/vehicle/create-deposit-release`,
  createTransferRelease: `${environment.apim}/vehicle/vehicle/create-transfer-release`,
  createTiresCampaign: `${environment.apim}/vehicle/vehicle/create-tyres-campaign`,
  updateTiresCampaign: `${environment.apim}/vehicle/vehicle/update-tyres-campaign`,
  tiresContractCampaign: `${environment.apim}/vehicle/vehicle/tyres-campaign`,
  maintenanceServiceCentersList: `${environment.apim}/management/service-centers`,
  maintenanceServiceCenterDetail: `${environment.apim}/services/service-center`,
  transferCentersList: `${environment.apim}/management/transfer-centers-by-location`,
  sendMailNotification: `${environment.apim}/order/order/send-email-vehicle-pickup`,

  // Contracts
  contracts: `${environment.apim}/contract/contracts`,
  contracts_detail: `${environment.apim}/contract/contract/details`,
  contractsExport: `${environment.apim}/contract/contracts/export`,
  earlyReturnQuotation: `${environment.apim}/contract/contracts/download-early-return`,
  changeDeadlineExtension: `${environment.apim}/contract/contract/change-deadline-extension-wtc`,
  changeContract: `${environment.apim}/contract/contract/change-contract-wtc`,
  changeRequest: `${environment.apim}/contract/contract/change-request-wtc`,
  sendEmailPurchaseEndRental: `${environment.apim}/contract/contracts/send-email-purchase-end-rental`,
  endContract: `${environment.apim}/contract/contract`,
  contracts_list_export: `${environment.apim}/contract/contract/update-list-export`,

  //Customer Service Management 
  sent_mail_history: `${environment.apim}/order/order/sent-mail-history`,
  mailup_update: `${environment.apim}/order/order/mailup-update`,

  // Manage profiles
  driver_list: `${environment.apim}/user/user/driver-list`,
  driver_list_v2: `${environment.apim}/user/user/driver-list-v2`,

  create_user_miles: `${environment.apim}/user/user/create-miles-user`,

  // Your Collaborator
  your_collaborators: `${environment.apim}/user/user/profile-management/user-collaborators`,
  your_collaborators_delete: `${environment.apim}/user/user/profile-management/remove-user-collaborator`,
  // Table api
  // filters: `${environment.toolUrl}/tools/filter-filename`,
  filters: `${environment.apim}/tool/tools/filter-filename`,
  columns: `${environment.apim}/tool/tools/columns`,
  columns_filename: `${environment.apim}/tool/tools/columns-filename`,

  // Notices comminucations
  notices_communications: `${environment.apim}/cms/cms/getalertssandcomunications`,
  notices_communications_export: `${environment.apim}/cms/cms/exportalertssandcomunications`,

  // USERPROFILE
  save_profile: `${environment.apim}/user/mws-contact/save-my-profile`,
  my_profile: `${environment.apim}/user/mws-contact/profile-registration`,

  // IFRAME
  prelease: `${environment.apim}/tool/tools/prelease`,
  car_configurator: `${environment.apim}/tool/tools/car-configurator`,
  car_sharing_url: `${environment.apim}/tool/tools/car-sharing`,
  vehicle_tax: `${environment.apim}/tool/tools/vehicle-tax`,

  // FORMS
  forms: `${environment.apim}/cms/cms/getmodules`,
  page_description: `${environment.apim}/cms/cms/getpagedescription`,
  manuals: `${environment.apim}/cms/cms/getmanuals`,
  products: `${environment.apim}/cms/cms/getproducts`,
  // SUPPORT
  support_request: `${environment.apim}/tool/tools/support-request`,

  // registration
  complete_registration: `${environment.apim}/user/mws-contact/complete-registration`,

  // utility wrapper
  association: `${environment.apim}/user/user/contact/update-association`,

  // HIERARCHY
  customer_hierarchy: `${environment.apim}/user/user/customer-hierarchy`,

  vehicle_expertise: `${environment.apim}/tool/tools/vehicle-expertise`,

  // Notifications:
  notifications_device_add: `${environment.apim}/notification/devices/add`,
  notifications_unread_count: `${environment.apim}/notification/devices/notifications/count`,
  notifications_list: `${environment.apim}/notification/devices/notifications`,
  notifications_read_status: `${environment.apim}/notification/devices/saveReadStatusNotification`,

  // Quotator
  quotator: `${environment.apim}/management/administration/corporate-quoter/login`,
  contactCategoryList: `${environment.apim}/user/user/contact-category-list`,
  contactCategorySet: `${environment.apim}/management/administration/corporate-quoter/contact-categories-set`,

  // MANAGE PHONE VERIFICATION:
  generatePin: `${environment.apim}/user/contact/generate-pin`,
  activatePin: `${environment.apim}/user/contact/activate-pin`,

  // DENUNCE
  complaint_list: `${environment.apim}/tool/tools/complaint-list`,
  driver_complaint: `${environment.apim}/tool/tools/driver-complaint-list`,
  flee_complaint: `${environment.apim}/tool/tools/fm-complaint-list`,
  insert_claim: `${environment.apim}/tool/tools/nemo-redirect-newclaims`,
  export_driver_claims: `${environment.apim}/tool/complaint/export-driver-complaint-list`,
  export_fm_claims: `${environment.apim}/tool/complaint/export-fleetmanager-complaint-list`,
  typologies: `${environment.apim}/tool/tools/load-typologies`,
  claimAttachmentDownload:`${environment.apim}/tool/complaint/nemo-attachment-download`,
  flee_complaint_new: `${environment.apim}/tool/tools/fm-complaint-list-new`,
  driver_complaint_new: `${environment.apim}/tool/tools/driver-complaint-list-new`,
  claim_detail: `${environment.apim}/tool/complaint/claim-detail`,
  export_driver_claimsNew: `${environment.apim}/tool/complaint/export-driver-complaint-list-new`,
  export_fm_claimsNew: `${environment.apim}/tool/complaint/export-fleetmanager-complaint-list-new`,
  
  // Appuntamenti
  service_centers: `${environment.apim}/management/service-centers-by-location`,
  service_centers_detail: `${environment.apim}/management/service-center`,
  service_centers_export: `${environment.apim}/management/service-centers/export`,
  appointment: `${environment.apim}/order/appointment`,
  appointmentList: `${environment.apim}/order/appointments`,

  // add driver
  inviteDriver: `${environment.apim}/user/user/add-invite-driver`,
  connect_user: `${environment.apim}/user/user/link-profile`,

  contractual_modification_history: `${environment.apim}/contract/contract/update-list`,
  contractual_modification_change: `${environment.apim}/contract/contract/add-update`,

  customer_info: `${environment.apim}/user/user/customer-info`,
  contacts: `${environment.apim}/user/user/get-contacts`,
  contact_profile_by_ext: `${environment.apim}/user/user/contact-profile-ext`,
  retrieve_contact_art94: `${environment.apim}/user/user/retrieve-contact`,
  update_contact_art94: `${environment.apim}/user/user/update-contact`,
  commercial_roles: `${environment.apim}/user/customer/commercial-roles`,
  commercial_roles_export: `${environment.apim}/user/customer/commercial-roles-export`,
  check_delega_contacts: `${environment.apim}/user/check-delega-contacts`,
  user_log: `${environment.apim}/user/user/log`,
  my_contracts: `${environment.apim}/vehicle/vehicle/my-contracts`,
  my_contracts_v2: `${environment.apim}/vehicle/vehicle/my-contracts-v2`,
  service_centers_suplier: `${environment.apim}/management/service-centers-by-supllier`,
  has_manutenzione: `${environment.apim}/user/user/has-manutenzione`,
  has_request_delivery_appointment: `${environment.apim}/contract/contract/request/delivery/appointments`,
  retrieve_codice_gruppo: `${environment.apim}/user/user/retrieve-codice-capogruppo`,
  exclusion_functionality_by_codice_gruppo: `${environment.apim}/user/user/get-exclusionsfunctionality`,

   //POSTE ITALIANE
   maintenance_plan_canali_digitali: `${environment.apim}/order/canalidigitali/maintenance`,
   maintenance_plan_canali_digitali_export: `${environment.apim}/order/canalidigitali/maintenance/export`,
   short_term_prenotazioni_relief: `${environment.apim}/tool/complaint/poste/prenotazioni-relief`,

  //ILocator
  ilocator_service_center_supplier: `${environment.apim}/management/iLocator/service-centers-supplier`,
  ilocator_service_center: `${environment.apim}/management/iLocator/service-centers`,
  ilocator_service_center_by_plate: `${environment.apim}/management/iLocator/service-centers-by-plate`,
  ilocator_marche : `${environment.apim}/management/iLocator/marche`,
  ilocator_transfer_centers: `${environment.apim}/management/iLocator/transfer-centers-by-location`,
  ilocator_service_center_by_location: `${environment.apim}/management/iLocator/service-centers-by-location`,
    ilocator_service_center_export: `${environment.apim}/management/iLocator/service-centers/export`,
    ilocator_service_center_by_supplier: `${environment.apim}/management/iLocator/service-centers-by-supplier`,
  

    //WEBFORM
    retrieve_triplet: `${environment.apim}/management/retrieve-triplette-webform`,
    retrieve_triplet_notlogged: `${environment.apim}/management/retrieve-triplette-webform-notlogged`,
    create_request: `${environment.apim}/management/create-request-webform`,
    search_bookings_mobility: `${environment.apim}/order/MobilitySearch`,
    search_bookings_mobility_not_logged: `${environment.apim}/order/MobilitySearchNotLogged`,
    search_requests_not_logged: `${environment.apim}/management/search-request-webform-not-logged`,
    get_cod_cost_center: `${environment.apim}/vehicle/vehicle/getCodCostCenter`,
    search_request_history: `${environment.apim}/management/search-request-webform`,

    //MANDATI
    search_mandates: `${environment.apim}/management/inserisci-mandato-list`,
    insert_mandate_add: `${environment.apim}/management/inserisci-mandato-add`,
};
export const aldconf = {
  general_info:
    "https://noleggio.ayvens.com/it-it/informazioni-legali/",
  societe_generale: "https://www.societegenerale.com/",
  ald_automotive: "https://www.ayvens.com/it-it/",
  corporate_governance: "https://www.ayvens.com/it-it/corporate-governance/corporate-governance-ald/",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "FppHV4Bn5L7hsuQIsY4586w7FKQa",
  clientId: "wHrVE1cw8V7QAj2omkicXp_mZZ4a",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const fordconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "CwllTKBwk8cKeu6i4dGnC3ArdEoa",
  clientId: "XAQ8RZEjtaKouC49rhgbXklajBka",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const fordFmconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "5ypq7CKDl3fBmsyMSdTcqK8nmeUa",
  clientId: "mNN_bUEqAcYQ6fo6r2KbE81v7Gsa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const hiundayconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "BAbmR_AYo2dpaMxzRgGj8pFY9tMa",
  clientId: "Fo06LfiPmutrfALIXDeoqARpzuYa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const suzukiconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "1hlJoNBsPXBaNI_99FI6m7LJFzQa",
  clientId: "qgl2GUpeN7592T_FRYIPQunbvbEa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const hondaconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "nRfaWHIMdCE3UigAJpavjTJ8Tb0a",
  clientId: "3CddxK5Hc7RtUNrz75GN3emDzrwa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const landroverconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "z16Lidqu3gOK5UXt75t1XhbZw4Ya",
  clientId: "mCfKaaxTilx18oCyolrzP0oRz2ca",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const jaguarconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "egkHHf9SI527t56haeVOwxjLwv8a",
  clientId: "vjxuYHgZu8tBmZaDpwffORvAzoEa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const smartconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "jr4tGyxgq44DSOmh4L1nLT5MSCUa",
  clientId: "gAenAfG8fny7wshNhh1OrKQq4XIa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const lynkcoconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "M1pmogoOnTNd8_nHRlbjqPcfLRQa",
  clientId: "g9h0fYdXYM9NNyLQnW_hSv_v3lAa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const omodajaecooconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "YPMS6fS0TnWVk7Gu1nyJhfSDTT8a",
  clientId: "x61V2Ly4M_Pfgfjs7QyIQFvXxhsa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const mgconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "VpNhfTuy5bL372kkANIn1QWrlgAa",
  clientId: "8hurDLNDCNO3hmZdUzQe6IJ_Os0a",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const fordfleetmanagementconf = {
  general_info: "",
  societe_generale: "",
  ald_automotive: "",
  corporate_governance: "",
  privacy: "https://www.ayvens.com/it-it/informativa-privacy/",
  dummyClientSecret: "5ypq7CKDl3fBmsyMSdTcqK8nmeUa",
  clientId: "mNN_bUEqAcYQ6fo6r2KbE81v7Gsa",
  issuer: "https://uat-passport.aldautomotive.it/oauth2/token",
  tokenEndpoint: "https://uat-passport.aldautomotive.it/oauth2/token",
  userinfoEndpoint: "https://uat-passport.aldautomotive.it/oauth2/userinfo",
  showDebugInformation: true,
  loginUrl: "https://uat-passport.aldautomotive.it/oauth2/authorize",
  requireHttps: false,
  responseType: "code",
  scope: "openid profile",
  oidc: true,
  logoutUrl: "https://uat-passport.aldautomotive.it/oidc/logout",
};

export const avoidHomeInitWelcome = {
  showed:false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
